import { getSlidersByPage } from '@services/sliders/sliders.services';
import { GetStaticProps } from 'next';
import { ESliderPageType } from 'src/components/slider/Slider/Slider.enum';
import { formatSliders } from 'src/components/slider/Slider/Slider.functions';
export { HomePage as default } from 'src/features/home/components/HomePage/HomePage';

export const getStaticProps: GetStaticProps = async () => {
	// fetch and format home page data
	const homeOverviewData = await getSlidersByPage(ESliderPageType.home);
	const formattedHomeOverviewData = formatSliders(homeOverviewData.sliders.data);

	return {
		props: {
			overview: formattedHomeOverviewData
		},
		revalidate: process.env.BUILD_ENV === 'production' ? 60 * 60 /* 1 hour */ : 60 /* 1 minute */
	};
};
